import { useMemo } from 'react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Html } from '@react-three/drei'
import { useOperationSteps } from '@/services/queries/operation_steps'
import { useCADPageStore } from '@/state'

export const EmptyCADHelperText = () => {
  const { isLoading, steps } = useOperationSteps()
  const selectedStep = useCADPageStore((state) => state.operationStep)

  const shouldRenderHelperText = useMemo(() => {
    const step = steps.find((s) => s.id === selectedStep?.stepId)
    const size = step?.assembly_group_ids.length || 0
    return size === 0
  }, [selectedStep, steps])

  if (isLoading || !shouldRenderHelperText || !selectedStep) {
    return
  }

  return (
    <Html
      wrapperClass="transform-none w-full h-full flex items-center justify-center bg-transparent !z-20 select-none !left-60"
      center
    >
      <Alert variant="default" className="w-fit">
        <div className="flex items-center space-x-2">
          <AlertDescription>
            👉 Drag a part from the Assembly Tree or use Add Parts from CAD to
            get started.
          </AlertDescription>
        </div>
      </Alert>
    </Html>
  )
}
